import { useSmartApplyVariant } from '@percent/cause-dashboard/common/hooks/useSmartApplyVariant'
import { SmartApplyPartner } from '@percent/cause-dashboard/constants/smartApplyPartners'
import { SmartApplyVariantA } from './smartApplyVariantA/SmartApplyVariantA'

type SmartApplyVariantRouterProps = {
  hasCanvaApplication: boolean
  setSelectedPartner?: (partner: SmartApplyPartner) => void
  appliedPartners?: Set<SmartApplyPartner>
  page?: number | null
  pagesCount?: number
  secondaryAction?: () => void
  onClose: () => void
  registerDismissCallback?: (callback: (() => void) | null) => void
}

export function SmartApplyVariantRouter(props: Readonly<SmartApplyVariantRouterProps>) {
  const { variant } = useSmartApplyVariant()

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const noop = () => {}
  const setSelectedPartner = props.setSelectedPartner || noop

  switch (variant) {
    case 'variant_a':
    default:
      return <SmartApplyVariantA {...props} setSelectedPartner={setSelectedPartner} />
  }
}
